import http from "./httpClient.js";

export async function getSchoolPublicProfile(schoolId) {
    const response = await http.get(`/school/${schoolId}/public-profile`);
    return response.data;
}
